module.exports = __webpack_public_path__ + "static/media/SellerboxFunction04.70f51cd8.png";